export const createSelectList = (list, isLocations = false) => {
  const newList = [];
  (list || []).map((item, index) =>
    newList.push({
      title: isLocations
        ? `${item.locationName}, ${item.locationAddress.address}`
        : item.value,
      value: isLocations ? item.id : item.key,
    }),
  );

  return newList;
};
